/*
 * trial-only-cart.js
 * トライアル商品の購入制限
 *
 *  1. トライアル商品は、他の商品と一緒にカートへ入れられない（逆方向も同じ）
 *  2. トライアル商品は、1回のご注文につき TRIAL_CONFIG.maxQty 点まで
 *
 * 対象商品は「トライアル商品」コレクション（ハンドル: trial-products）で決まる。
 * 商品ページでタグ trial を付ける／外すだけで御社側でも変更できる。
 * 設定は layout/theme.liquid の window.TRIAL_CONFIG。
 */
(function () {
  'use strict';

  var CFG = window.TRIAL_CONFIG || {};
  var IDS = (CFG.variantIds || []).map(String);
  var MAX = Number(CFG.maxQty || 0);
  // full = 画面下部の案内 / short = ボタンに出す短い文言
  // すでにカートにトライアル商品が入っていて、他の商品を追加しようとした
  var M_TRIAL_IN_CART = {
    full:
      CFG.msgTrialInCart ||
      'カートにトライアル商品が入っています。トライアル商品は単独でのご購入となりますので、他の商品は別のご注文としてお願いいたします。',
    short: CFG.shortTrialInCart || 'トライアル商品と同時に購入できません',
  };
  // すでにカートに他の商品が入っていて、トライアル商品を追加しようとした
  var M_OTHER_IN_CART = {
    full:
      CFG.msgOtherInCart ||
      'トライアル商品は単独でのご購入となります。お手数ですが、カート内の商品とは分けてご注文ください。',
    short: CFG.shortOtherInCart || 'トライアル商品は単独購入のみです',
  };
  // 数量の上限を超えた
  var M_QTY = {
    full: CFG.msgQty || 'トライアル商品は、1回のご注文につき1点までとなります。',
    short: CFG.shortQty || 'お一人様1点までです',
  };

  // 対象商品が未設定なら何もしない（コレクション未作成でも安全）
  if (!IDS.length) return;

  function isTrial(id) {
    return IDS.indexOf(String(id)) !== -1;
  }

  function getCart() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (r) {
      return r.json();
    });
  }

  /* ------------------------------------------------------------------ *
   * お知らせ表示
   * ------------------------------------------------------------------ */
  var toastEl = null;
  var toastTimer = null;

  function toast(text) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.setAttribute('role', 'alert');
      toastEl.style.cssText = [
        'position:fixed',
        'left:50%',
        'bottom:28px',
        'transform:translateX(-50%) translateY(12px)',
        'z-index:2147483647',
        'max-width:min(560px,calc(100vw - 32px))',
        'background:#2f2a24',
        'color:#fff',
        'padding:15px 22px',
        'border-radius:10px',
        'font-size:14px',
        'line-height:1.75',
        'text-align:center',
        'box-shadow:0 14px 36px rgba(0,0,0,.3)',
        'opacity:0',
        'transition:opacity .2s ease, transform .2s ease',
        'pointer-events:none',
      ].join(';');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    requestAnimationFrame(function () {
      toastEl.style.opacity = '1';
      toastEl.style.transform = 'translateX(-50%) translateY(0)';
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.style.opacity = '0';
      toastEl.style.transform = 'translateX(-50%) translateY(12px)';
    }, 5000);
  }

  /* ------------------------------------------------------------------ *
   * リクエストの中身を読む
   * ------------------------------------------------------------------ */
  function bodyToObject(body) {
    // FormData / JSON文字列 / URLエンコード文字列 のいずれにも対応する
    if (body instanceof FormData) {
      var o = {};
      body.forEach(function (v, k) {
        o[k] = v;
      });
      return o;
    }
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        var o2 = {};
        new URLSearchParams(body).forEach(function (v, k) {
          o2[k] = v;
        });
        return o2;
      }
    }
    if (body && typeof body === 'object') return body;
    return {};
  }

  // 追加しようとしている {id, qty} の配列を取り出す
  function parseAdd(body) {
    var o = bodyToObject(body);
    var out = [];
    if (o.id) out.push({ id: String(o.id), qty: Number(o.quantity || 1) });
    if (Array.isArray(o.items)) {
      o.items.forEach(function (it) {
        if (it && it.id) out.push({ id: String(it.id), qty: Number(it.quantity || 1) });
      });
    }
    // FormData の items[0][id] 形式
    Object.keys(o).forEach(function (k) {
      var m = k.match(/^items\[(\d+)\]\[id\]$/);
      if (m) out.push({ id: String(o[k]), qty: Number(o['items[' + m[1] + '][quantity]'] || 1) });
    });
    return out;
  }

  /* ------------------------------------------------------------------ *
   * 判定
   * ------------------------------------------------------------------ */

  // カートへの追加を許可してよいか。NGならメッセージを返す
  function checkAdd(adding) {
    if (!adding.length) return Promise.resolve(null);

    return getCart()
      .then(function (cart) {
        var linesTrial = cart.items.filter(function (i) {
          return isTrial(i.variant_id);
        });
        var hasOther = cart.items.some(function (i) {
          return !isTrial(i.variant_id);
        });

        var addTrial = adding.some(function (a) {
          return isTrial(a.id);
        });
        var addOther = adding.some(function (a) {
          return !isTrial(a.id);
        });

        // 1. 混在の禁止（どちらが原因かで案内を分ける）
        if (addOther && linesTrial.length) return M_TRIAL_IN_CART;
        if (addTrial && hasOther) return M_OTHER_IN_CART;
        if (addTrial && addOther) return M_OTHER_IN_CART;

        // 2. 数量の上限
        if (addTrial && MAX > 0) {
          var now = linesTrial.reduce(function (s, i) {
            return s + i.quantity;
          }, 0);
          var add = adding.reduce(function (s, a) {
            return s + (isTrial(a.id) ? a.qty : 0);
          }, 0);
          if (now + add > MAX) return M_QTY;
        }
        return null;
      })
      .catch(function () {
        return null; // 通信に失敗したときは買い物を止めない
      });
  }

  /* ------------------------------------------------------------------ *
   * カート内での数量変更
   *
   * ここは「拒否」ではなく「上限に丸めて通す」。
   * 拒否するとShopifyが再描画用のHTMLを返さないため、画面の数字だけが
   * 増えたまま残り、実際のカートとずれて見える。丸めて通せば正常に
   * 再描画され、数字が上限に戻る。
   * ------------------------------------------------------------------ */
  function findItem(cart, o) {
    if (o.line !== undefined && o.line !== null && o.line !== '') {
      return cart.items[Number(o.line) - 1];
    }
    if (o.id !== undefined && o.id !== null && o.id !== '') {
      return cart.items.filter(function (i) {
        return String(i.key) === String(o.id) || String(i.variant_id) === String(o.id);
      })[0];
    }
    return null;
  }

  // 変更後のオブジェクトを、元のリクエストと同じ形式に戻す
  function rebuildBody(obj, original) {
    if (original instanceof FormData) {
      var fd = new FormData();
      Object.keys(obj).forEach(function (k) {
        fd.append(k, obj[k]);
      });
      return fd;
    }
    if (typeof original === 'string') {
      try {
        JSON.parse(original);
        return JSON.stringify(obj);
      } catch (e) {
        var sp = new URLSearchParams();
        Object.keys(obj).forEach(function (k) {
          sp.append(k, obj[k]);
        });
        return sp.toString();
      }
    }
    return JSON.stringify(obj);
  }

  // 丸める必要があれば { msg, body } を、なければ null を返す
  function clampChange(body) {
    if (MAX <= 0) return Promise.resolve(null);
    var o = bodyToObject(body);

    // 1行だけの数量変更（Dawn のカート・カートドロワーはこの形）
    if (o.quantity !== undefined) {
      var qty = Number(o.quantity);
      if (!isFinite(qty) || qty <= MAX) return Promise.resolve(null);
      return getCart()
        .then(function (cart) {
          var item = findItem(cart, o);
          if (!item || !isTrial(item.variant_id)) return null;
          o.quantity = MAX;
          return { msg: M_QTY, body: rebuildBody(o, body) };
        })
        .catch(function () {
          return null;
        });
    }

    // まとめて更新する形式（/cart/update.js）
    if (o.updates && typeof o.updates === 'object' && !Array.isArray(o.updates)) {
      return getCart()
        .then(function (cart) {
          var changed = false;
          Object.keys(o.updates).forEach(function (k) {
            var q = Number(o.updates[k]);
            if (!isFinite(q) || q <= MAX) return;
            var item = cart.items.filter(function (i) {
              return String(i.variant_id) === String(k) || String(i.key) === String(k);
            })[0];
            if (item && isTrial(item.variant_id)) {
              o.updates[k] = MAX;
              changed = true;
            }
          });
          return changed ? { msg: M_QTY, body: rebuildBody(o, body) } : null;
        })
        .catch(function () {
          return null;
        });
    }

    return Promise.resolve(null);
  }

  /* ------------------------------------------------------------------ *
   * ブロック時に返す応答
   * Shopify のエラー形式に合わせるので、Dawn 標準のフォームは
   * 商品ページ内にそのままメッセージを表示してくれる
   * ------------------------------------------------------------------ */
  function blockedResponse(msg) {
    return new Response(
      JSON.stringify({
        status: 422,
        message: 'Cart Error',
        description: msg.full, // Dawn標準フォームが商品ページ内に表示する
        short: msg.short, // カスタムのボタンが表示する短い文言
        trial_blocked: true,
      }),
      { status: 422, headers: { 'Content-Type': 'application/json' } }
    );
  }

  var isAddUrl = function (u) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(u || ''));
  };
  var isChangeUrl = function (u) {
    return /\/cart\/(change|update)(\.js)?(\?|$)/.test(String(u || ''));
  };

  /* ------------------------------------------------------------------ *
   * fetch を横取り（Dawn標準・商品詳細・ラインナップのポップアップ すべて）
   * ------------------------------------------------------------------ */
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var body = (init && init.body) || (input && input.body);
    var self = this;
    var args = arguments;

    if (isAddUrl(url)) {
      return checkAdd(parseAdd(body)).then(function (msg) {
        if (msg) {
          toast(msg.full);
          return blockedResponse(msg);
        }
        return origFetch.apply(self, args);
      });
    }

    if (isChangeUrl(url)) {
      return clampChange(body).then(function (res) {
        if (!res) return origFetch.apply(self, args);
        toast(res.msg.full);
        // 数量を上限に書き換えたうえで、本来のリクエストとして送る
        var newInit = Object.assign({}, init || {}, { body: res.body });
        return origFetch.call(self, url, newInit);
      });
    }

    return origFetch.apply(this, arguments);
  };

  /* ------------------------------------------------------------------ *
   * XMLHttpRequest を横取り（古い実装・一部アプリ対策）
   * ------------------------------------------------------------------ */
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__trialAdd = isAddUrl(url);
    this.__trialChange = isChangeUrl(url);
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    var args = arguments;
    if (!this.__trialAdd && !this.__trialChange) return origSend.apply(this, args);

    if (this.__trialAdd) {
      checkAdd(parseAdd(body)).then(function (msg) {
        if (msg) {
          toast(msg.full);
          xhr.abort();
          return;
        }
        origSend.apply(xhr, args);
      });
      return;
    }

    clampChange(body).then(function (res) {
      if (!res) return origSend.apply(xhr, args);
      toast(res.msg.full);
      origSend.call(xhr, res.body); // 上限に丸めて送る
    });
  };

  /* ------------------------------------------------------------------ *
   * 通常のフォーム送信（JavaScriptを使わない導線）
   * ------------------------------------------------------------------ */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.__trialChecked) return;
      var action = form.getAttribute('action') || '';
      if (!isAddUrl(action)) return;

      e.preventDefault();
      checkAdd(parseAdd(new FormData(form))).then(function (msg) {
        if (msg) return toast(msg.full);
        form.__trialChecked = true;
        form.submit();
      });
    },
    true
  );
})();
